import { Link } from "react-router-dom";
import React, { ReactElement } from "react";

import "./footer.scss";
import i18n from "../assets/i18n";
import { useTranslation } from "react-i18next";

export default function Footer(): ReactElement {
  const { t } = useTranslation();
  const [currentLang, setCurrentLang] = React.useState<string>(i18n.language.substring(0,2));

  function setNewLang(newLang: ("de" | "en")) {
    if (currentLang === newLang) return;
    i18n.changeLanguage(newLang).then(() => setCurrentLang(newLang));
  }


  return (
    <footer className="app-body bg-black py-5 shadow-lg z-3">
      <div className="container">
        <div className="row">
          <div className="col-12 col-md-6 mb-5 text-center text-md-start">
            <h2 className="text-white">{t("footer.contact.title")}</h2>
            <p className="text-light">{t("footer.contact.body")}</p>
            <Link to="/contact" className="link-light link-underline-opacity-25 link-underline-opacity-100-hover">
              {t("footer.contact.contact_link")}
            </Link>
          </div>
          <div
            className="col-12 col-md-6 d-flex flex-column justify-content-start align-items-center align-items-md-end row-gap-2 text-light">
            <div className="col-6 col-md-5 col-lg-4 col-xl-3 mb-5">
              <img src="/assets/logo-niks-production.png" alt="Logo Niks Production"/>
            </div>
            <div>
              <i className="bi bi-whatsapp me-2 fs-4" title="WhatsApp-Icon"></i>
              <a className="link-light link-underline-opacity-25 link-underline-opacity-100-hover"
                 href="https://whatsapp.com/channel/0029Vb62Tbu11ulNs6T7Zy02" target="_blank"
                 rel="noreferrer">{t("footer.whatsapp_channel")}</a>
            </div>
            <div className="dropdown">
              <button className="btn btn-black border-0 p-0 dropdown-toggle text-light" data-bs-toggle="dropdown"
                      aria-expanded="false">
                <i className="bi bi-translate me-2 fs-4"></i>
                {t("footer.language_dropdown." + currentLang)}
              </button>
              <ul className="dropdown-menu bg-light">
                <li>
                  <button className="dropdown-item"
                          onClick={() => setNewLang("de")}>{t("footer.language_dropdown.de")}</button>
                </li>
                <li>
                  <button className="dropdown-item"
                          onClick={() => setNewLang("en")}>{t("footer.language_dropdown.en")}</button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}